<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="16" :offset="6">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="平台">
                            <el-select v-model="formInline.platformId" placeholder="平台" >
                                <el-option v-for="item in platformData"
                                           :key="item.platformId"
                                           :label="item.platformName"
                                           :value="item.platformId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品状态">
                            <el-select v-model="formInline.need_edit_spu" placeholder="商品状态">
                                <el-option v-for="item in statusList"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="getList()" size="mini" class="header-btn">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading" >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="交易组件平台内部商品ID" prop="product_id"></el-table-column>
            <el-table-column label="商家商品id" prop="out_product_id"></el-table-column>
            <el-table-column label="标题" prop="title"></el-table-column>
            <el-table-column label="绑定的小程序商品路径" prop="path"></el-table-column>
            <el-table-column label="商品线上状态" prop="status">
                <template slot-scope="scope">
                    <span>{{ getSaleStatus(scope.row.status)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="商品草稿状态" prop="edit_status">
                <template slot-scope="scope">
                    <span>{{ getEditStatus(scope.row.edit_status)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="第三级类目ID" prop="third_cat_id"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini"  @click="getDetail(scope.row)">查看明细</el-button>
                        <el-button type="success" size="mini" v-show="(scope.row.status==0||scope.row.status==11||scope.row.status==12||scope.row.status==13)&&scope.row.edit_status==4" @click="setOn(scope.row)">上架</el-button>
                        <el-button type="warning" size="mini" v-show="scope.row.status==5" @click="setOff(scope.row)">下架</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="明细" :visible.sync="showDialog">
            <el-table :data="skus" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="out_product_id" label="商家自定义商品ID" width="170" >
                </el-table-column>
                <el-table-column prop="out_sku_id" label="商家自定义skuID" width="170">
                </el-table-column>
                <el-table-column prop="sale_price" label="售卖价格,以分为单位" width="170">
                </el-table-column>
                <el-table-column prop="market_price" label="市场价格,以分为单位" width="170">
                </el-table-column>
                <el-table-column prop="stock_num" label="库存" width="170">
                </el-table-column>
                <el-table-column prop="barcode" label="条形码" width="170">
                </el-table-column>
                <el-table-column prop="sku_code" label="商品编码" fixed="right">
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        setProductOn,getPlatformList2,getminiProductList,setProductOff,deletProduct
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                formInline: {
                    platformId: 4,
                    currentPage: 1,
                    need_edit_spu:0,
                    pageSize: 20,
                    recordsTotal:0
                },
                categoryResult:false,
                audit_id:0,
                skus:[],
                loading:true,
                edit_status_list:[{id:0,name:'初始值'},{id:1,name:'编辑中'},{id:2,name:'审核中'},{id:3,name:'审核失败'},{id:4,name:'审核成功'}],
                status_list:[{id:0,name:'初始值'},{id:5,name:'上架'},{id:9,name:'逻辑删除'},{id:11,name:'自主下架'},{id:12,name:'售罄下架'},{id:13,name:'违规下架/风控系统下架'}],
                statusList:[{id:0,name:'线上数据'},{id:1,name:'草稿数据'}],
                list: []
            }
        },
        created() {

        },

        //挂载时候执行
        mounted(){
            this.getPlatfrom();
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                this.loading=true;
                getminiProductList(this.formInline).then((res) => {
                    this.loading=false;
                    console.log(res);
                    if (res.data.success) {
                        this.list = res.data.value.spus;
                        this.formInline.recordsTotal=res.data.value.total_num;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            add(){
               this.showDialog=true;
            },
            getSaleStatus(status){
                for ( var i = 0; i <this.status_list.length; i++){
                    if(this.status_list[i].id==status){
                        return this.status_list[i].name;
                    }
                }
                return '';
            },
            getEditStatus(status){
                for ( var i = 0; i <this.edit_status_list.length; i++){
                    if(this.edit_status_list[i].id==status){
                        return this.edit_status_list[i].name;
                    }
                }
                return '';
            },
            setOn(row){
                setProductOn({product_id:row.product_id,out_product_id:row.out_product_id}).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            setOff(row){
                setProductOff({product_id:row.product_id,out_product_id:row.out_product_id}).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleDel(row){
                this.$confirm('确定删除选中的行吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deletProduct({product_id:row.product_id,out_product_id:row.out_product_id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            getDetail(row){
                this.showDialog=true;
                this.skus=row.skus;
            },
            getPlatfrom(){
                //初始化首页数据
                getPlatformList2().then((res) => {
                    this.platformData = res.data;
                });
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/minishop/shopproduct.vue